import styles from "./notification.module.css";
import Helmet from "react-helmet";
import Footer from "../../components/Footer";
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Slide, Snackbar, TablePagination, Typography } from "@mui/material";
import { Home, X } from "react-feather";
import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import Loader from "../../components/Loader";
import NotificationCard from "./components/NotificationCard";
import NotificationFilter from "./components/NotificationFilter";
import { useEffect, useState } from "react";
import axios from "axios";
import { TableLoaderSmall } from "../../components/LoaderC";
import { toast } from 'react-smart-toaster';

const Notification = () => {
  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [filterData, setFilterData] = useState({ searchKey: "", type: "" });
  const [archiveModalOpen, setArchiveModalOpen] = useState(false);
  const [publishModalOpen, setPublishModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(false);
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(8);

  useEffect(() => {
    const geNotificationList = async () => {
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

      axios(process.env.REACT_APP_USER_API_URL + "v1/email-sms-contents", {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      }).then((response) => {
        setContentLoading(false);
        setAllData(response.data.data);
      }).catch(() => {
        setContentLoading(false);
      });
    }

    geNotificationList();
  }, [getAccessTokenSilently]);

  useEffect(() => {
    if (allData.length > 0) {
      let filteredDataTemp = allData;

      if (filterData.searchKey !== "") {
        let inputVal = filterData.searchKey;
        inputVal = inputVal.toLowerCase();
        filteredDataTemp = filteredDataTemp.filter((item) => {
          return item.category.toLowerCase().includes(inputVal);
        });
      }

      if (filterData.type !== "" && filterData.type !== "all") {
        filteredDataTemp = filteredDataTemp.filter((i) => i.type === filterData.type);
      }

      setFilteredData(filteredDataTemp);
    }
  }, [allData, filterData]);

  const changeStatusConfirm = async (data) => {
    setLoading(true);
    setArchiveModalOpen(false);
    setPublishModalOpen(false);
    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    axios.put(process.env.REACT_APP_USER_API_URL + 'v1/email-sms-contents/' + selectedItem?.id, { is_archived: data }, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      setLoading(false);

      setSnackbarMsg("Email campaign updated successfully.");
      setSnackbarOpen(true);

      setAllData(prev => {
        return prev?.map((item) => {
          if (item.id === selectedItem?.id) {
            return { ...item, is_archived: data };
          }
          return item;
        })
      });

      setSelectedItem(null);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  }

  return (<>
    <Helmet title="Manage notification" />

    {loading && <Loader />}

    <div className={`${styles.pageTitleWrap}`}>
      <Typography display="inline" className={`${styles.pageTitle}`}>Manage notification</Typography>
      <nav aria-label="breadcrumb">
        <ol className={`${styles.breadcrumb}`}>
          <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Notification</li>
          <li className={`${styles.breadcrumbItem} ${styles.active}`}>Manage notification</li>
        </ol>
      </nav>
    </div>

    <div className={`${styles.BodyCon}`}>
      <div className={`${styles.mainCardDiv}`}>
        <div className={`${styles.mainCard}`}>

          {contentLoading && (<div className="Loader TableLoader">
            <TableLoaderSmall />
          </div>)}

          {!contentLoading && (<div className="control-pane">
            <div className={`${styles.Row}`}>

              <NotificationFilter setFilterData={setFilterData.bind(this)} />

              <div className={`${styles.NotesRow}`}>

                {filteredData?.map((item, index) => {
                  return perPage === -1 || (index >= page * perPage && index < page * perPage + perPage) ? <NotificationCard item={item} setArchiveModalOpen={setArchiveModalOpen.bind(this)} setPublishModalOpen={setPublishModalOpen.bind(this)} setSelectedItem={setSelectedItem.bind(this)} /> : null;
                })}

              </div>

              {filteredData.length > 0 && (<div className="Pagination TablePaginationNew List">
                <TablePagination
                  count={filteredData.length}
                  color="primary"
                  page={page}
                  rowsPerPage={perPage}
                  onPageChange={(e, v) => setPage(v)}
                  rowsPerPageOptions={[
                    { label: "4", value: 4 },
                    { label: "8", value: 8 },
                    { label: "16", value: 16 },
                    { label: "All", value: -1 },
                  ]}
                  onRowsPerPageChange={(e) => {
                    setPage(0);
                    setPerPage(e.target.value);
                  }}
                  labelRowsPerPage={"Notifications per Page:"}
                />
              </div>)}

              {filteredData.length === 0 && (<div className={`${styles.NoDataMain}`}>
                <div className={`${styles.NoDataIMG}`}>
                  <img src="/static/img/no-prospect.png" alt="No Data" />
                </div>
                <p className={`${styles.NoDataText}`}>Let's get started!</p>
                <p className={`${styles.NoDataTextSub}`}>You don't have any notification saved.</p>
              </div>)}

            </div>
          </div>)}
        </div>
      </div>
    </div>

    <Dialog
      open={archiveModalOpen}
      onClose={(e) => setArchiveModalOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle id="alert-dialog-title">Are you sure you want to archive email campaign?<button onClick={(e) => setArchiveModalOpen(false)}><X /></button></DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div className="ModalFormGroup">
            <label className="PopupBodyText">The lemail campaign will be archived immediately. You can publish it at any time.</label>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <button onClick={(e) => setArchiveModalOpen(false)} className="CancelPopupBU">Cancel</button>
        <button className="SubmitPopupBU" onClick={(e) => changeStatusConfirm(1)}>Archive</button>
      </DialogActions>
    </Dialog>

    <Dialog
      open={publishModalOpen}
      onClose={(e) => setPublishModalOpen(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle id="alert-dialog-title">Are you sure you want to publish email campaign?<button onClick={(e) => setPublishModalOpen(false)}><X /></button></DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <div className="ModalFormGroup">
            <label className="PopupBodyText">The email campaign will be published immediately. You can unpublish it at any time.</label>
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <button onClick={(e) => setPublishModalOpen(false)} className="CancelPopupBU">Cancel</button>
        <button className="SubmitPopupBU" onClick={(e) => changeStatusConfirm(0)}>Publish</button>
      </DialogActions>
    </Dialog>

    <Snackbar
      open={snackbarOpen}
      onClose={(e) => setSnackbarOpen(false)}
      TransitionComponent={Slide}
      message={snackbarMsg}
      autoHideDuration={10000}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      action={
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={(e) => setSnackbarOpen(false)}
        >
          <X />
        </IconButton>
      }
    />

    <Footer />
  </>
  )
}

export default withAuthenticationRequired(Notification, {
  onRedirecting: () => <Loader />,
});